<template>
    <div class="app-container">
        <div class="header">{{ null }}</div>
        <nav class="add-navigation d-flex flex-column flex-sm-row align-items-sm-center align-items-start justify-content-sm-between">
            <div
                    @click="$router.push({ name: 'system-admin-filters' })"
                    class="back-link mb-3 mb-sm-0"
            >
                <svg
                        class="icon"
                        width="30px"
                        height="30px"
                        viewBox="0 0 30 30"
                        version="1.1"
                >
                    <path
                            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
                            id="path-1"
                    />
                </svg>
                <p>Back to Filters</p>
            </div>
            <div class="buttons-wrapper">
                <div
                        @click="$router.push({ name: 'system-admin-filters' })"
                        class="secondary-button"
                >
                    <secondary-button>Cancel</secondary-button>
                </div>
                <div class="primary-button">
                    <primary-button @click.native="editFilter"
                    >Save Filter
                    </primary-button
                    >
                </div>
            </div>
        </nav>
        <div class="add-container">
            <span class="container-title">Edit Filter</span>
            <div class="row px-3 pt-4">
                <div class="col-md-6 col-12">
                    <div class="list primary-input-container">
                        <p class="pimary-input-title">Select Clients</p>
                        <multiselect
                                v-model="filter.companies"
                                name="company"
                                :options="companies"
                                :value="companies"
                                :multiple="true"
                                :close-on-select="false"
                                :clear-on-select="false"
                                :preserve-search="true"
                                placeholder="Pick Client"
                                label="company_name"
                                track-by="company_uuid"
                                :preselect-first="true"
                        >
                            <template
                                    slot="selection"
                                    slot-scope="{ values, search, isOpen, option }"
                            >
                <span
                        class="multiselect__single"
                        v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }}
                  {{
                    values.length === 1 ? "company" : "companies"
                  }}
                  selected</span
                >
                            </template>
                        </multiselect>
                    </div>
                    <!-- <div class="help is-danger" v-if="errors.has('company')">{{ errors.first('company') }}</div> -->
                    <div class="help is-danger" v-if="filterError">
                        {{ filterError.company ? filterError.company[0] : null }}
                    </div>

                </div>

                <div class="col-md-6 col-12">
                    <div class="list primary-input-container">
                        <p class="pimary-input-title">Select Vendors</p>
                        <multiselect
                                v-model="filter.vendors"
                                name="vendor"
                                :options="vendors"
                                :value="vendors"
                                :multiple="true"
                                :close-on-select="false"
                                :clear-on-select="false"
                                :preserve-search="true"
                                placeholder="Pick Vendors"
                                label="vendor_name"
                                track-by="vendor_uuid"
                                :preselect-first="true"
                        >
                            <template
                                    slot="selection"
                                    slot-scope="{ values, search, isOpen, option }"
                            >
                <span
                        class="multiselect__single"
                        v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }}
                  {{
                    values.length === 1 ? "vendor" : "vendors"
                  }}
                  selected</span
                >
                            </template>
                        </multiselect>
                    </div>
                    <!-- <div class="help is-danger" v-if="errors.has('vendor')">{{ errors.first('vendor') }}</div> -->
                    <!-- <div
                      class="help is-danger"
                      v-if="filterError"
                    >{{filterError.vendor ? filterError.vendor[0] : null}}</div>-->
                    <!-- <primary-select
                      type="text"
                      name="type"
                      v-validate="'required'"
                      :class="{'input': true, 'is-danger': errors.has('type')}"
                      v-model="filter.type"
                      placeholder="Type"
                    >
                      <option value="None">None</option>
                    </primary-select>
                    <div class="help is-danger" v-if="errors.has('type')">{{ errors.first('type') }}</div>-->
                </div>
                <div class="col-md-6 col-12">
                    <primary-input
                            type="text"
                            name="text"
                            class="field second-line"
                            v-model="filter.text"
                            v-validate="'required'"
                            :class="{ input: true, 'is-danger': errors.has('text') }"
                            placeholder="Enter text number"
                    />
                    <div class="help is-danger" v-if="errors.has('text')">
                        {{ errors.first("text") }}
                    </div>
                    <div class="help is-danger" v-if="filterError">
                        {{ filterError.text ? filterError.text[0] : null }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {
            PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
            PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
            SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
            PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
        },
        data: () => ({
            filterError: null,
            type: ["None", "one or more", "all clients"],
            filter: {},
            vendors: [],
            companies: [],
        }),
        created() {
            this.getVendorsList();
            this.getCompanyList();
            this.GetFilter();
        },
        methods: {
            GetFilter() {
                this.$store.dispatch("GetFilter", this.$route.params.id).then((res) => {
                    this.filter = {
                        companies: res.companies.length
                            ? res.companies
                            : [{company_name: "All", company_uuid: ""}],
                        created_by: res.created_by,
                        created_on: res.created_on,
                        stop_text_uuid: res.stop_text_uuid,
                        text: res.text,
                        vendors: res.vendors.length
                            ? res.vendors
                            : [{vendor_name: "All", vendor_uuid: ""}],
                    };
                });
            },
            async getVendorsList() {
                const {total} = await this.$store.dispatch("GetVendorList", {});

                const {items} = await this.$store.dispatch("GetVendorList", {
                    perPage: total,
                });
                this.vendors = items;
            },
            getCompanyList() {
                this.$store.dispatch("GetCompanyList", {}).then((res) => {
                    let {total} = res;
                    this.$store
                        .dispatch("GetCompanyList", {perPage: total})
                        .then((res) => {
                            this.companies = res.items;
                            this.companies.unshift({company_name: "All", company_uuid: ""});
                            this.vendors.unshift({vendor_name: "All", vendor_uuid: ""});
                        });
                });
            },
            transformCompanies(elem) {
                return {
                    company_uuid: elem.company_uuid,
                };
            },
            transformVendors(elem) {
                return {
                    vendor_uuid: elem.vendor_uuid,
                };
            },
            filterCompanies(elem) {
                return elem.company_uuid;
            },
            filterVendor(elem) {
                return elem.vendor_uuid;
            },
            editFilter() {
                this.$validator.validate().then((result) => {

                    if (result) {

                        this.filter.companies = this.filter.companies
                            .map(this.transformCompanies)
                            .filter(this.filterCompanies);
                        this.filter.vendors = this.filter.vendors
                            .map(this.transformVendors)
                            .filter(this.filterVendor);

                        this.$store
                            .dispatch("EditFilter", {
                                filter: this.filter,
                                id: this.$route.params.id,
                            })
                            .then(() => {
                                this.$snotify.success("Filter have been edited.", {
                                    timeout: 6000,
                                });
                                this.$router.push({name: "system-admin-filters"});
                            })
                            .catch((err) => {
                                if (err.errors) {
                                    this.filterError = err.errors[0].filter
                                        ? err.errors[0].filter
                                        : null;
                                    setTimeout(() => {
                                        this.filterError = null;
                                    }, 6000);
                                } else {
                                    this.$snotify.error(err.response.data.errors, {
                                        timeout: 6000,
                                    });
                                }
                            });
                    }
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
    .app-container {
        font-family: "Helvetica Neue";
        padding: 0 20px;

        .row {
          .primary-input-container {
             margin-bottom: 20px;
          }

            .pimary-input-title {
                margin-bottom: .5rem;
                font-weight: 400;
            }
        }

        .header {
            //padding: 15px 0;
            font-size: 22px;
            color: #666;
        }

        .add-navigation {
            width: 100%;
            margin-bottom: 20px;

            .back-link {
                cursor: pointer;
                display: flex;
                align-items: center;
                fill: #51a3f3;
                color: #51a3f3;
                font-family: "Helvetica Neue";
                font-size: 16px;
                font-weight: 500;
                line-height: 20px;

                p {
                    margin-bottom: 0;
                }
            }

            .buttons-wrapper {
                display: flex;
                align-items: center;
                width: fit-content;

                .primary-button {
                    height: 40px;
                    width: 145px;
                }

                .secondary-button {
                    height: 40px;
                    width: 90px;
                    margin-right: 20px;
                }
            }
        }

        .add-container {
            flex-direction: column;
            align-items: center;
            height: 375px;
            background-color: #ffffff;
            padding-top: 15px;

            .container-title {
                height: 30px;
                width: 432px;
                color: #000000;
                font-size: 16px;
                font-weight: 500;
                line-height: 30px;
                padding: 15px 0 15px 15px;
            }

            .col-wrapper {
                width: 100%;
                display: flex;
                justify-content: space-between;
                padding-left: 15px;
                margin-top: 20px;

                .col {
                    width: 100%;
                    margin-right: 15px;
                    padding: 0;

                    .input {
                        margin-bottom: 20px;
                    }

                    .field {
                        p.pimary-input-title {
                            color: #000000;
                            font-family: "" Helvetica Neue "";
                            font-size: 12px;
                            font-weight: 300;
                        }
                    }

                    .type {
                        margin-top: 20px;
                    }

                    .pimary-input-title {
                        color: #000000;
                        font-family: "" Helvetica Neue "";
                        font-size: 12px;
                        font-weight: 300;
                        letter-spacing: 0.21px;
                        line-height: 15px;
                        margin-bottom: 5px;
                        text-transform: uppercase;
                    }

                    .second-line {
                        margin-top: 20px;
                    }
                }
            }

            .email-input {
                margin-bottom: 20px;
            }

            .password-input {
                margin-bottom: 30px;
            }

            .first {
                margin-bottom: 30px;

                .remember-me {
                    display: flex;
                    align-items: center;

                    input {
                        margin-right: 5px;
                    }
                }
            }
        }
    }
</style>

